import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-平台费率",
  "use": "icon-平台费率-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-平台费率\">\n<g transform=\"translate(2 2) scale(0.75)\">\n<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"0.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n\t<path d=\"M2.4,4.1h11.2c0.6,0,1,0.4,1,1v7.3c0,0.6-0.4,1-1,1H2.4c-0.6,0-1-0.4-1-1V5.1C1.4,4.5,1.8,4.1,2.4,4.1z\" />\n\t<path d=\"M1.4,6.1h13.2\" />\n\t<path d=\"M5.3,11l5.4-5.4\" />\n</g>\n<g fill=\"currentColor\">\n\t<circle cx=\"5.4\" cy=\"5.8\" r=\"0.8\" />\n\t<circle cx=\"10.6\" cy=\"10.8\" r=\"0.8\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/平台费率.svg
// module id = +SlJ
// module chunks = 166